module.exports = __webpack_public_path__ + "img/advanced6.0c7bf918.png";